import React from "react";
import { connect } from "react-redux";
import type { RouterHistory } from "react-router-dom";
import { getEntityItems, readEntities } from "../../redux/api";
import { setConfig } from "../../redux/reducers/configuration-reducer";
import OptionSelectorSwitch from "../../shared/controls/option-selector-switch";
import { Flex } from "../../shared/styled/flex";
import { View, ViewTitle } from "../../shared/styled/view";
import { normalizeStr } from "../../shared/utils";
import AssembleShipmentSummaryList from "./assemble-shipment-summary-list";
// import { View, ViewTitle } from "../../shared/styled/view";
import HelperFilesModal from '../../shared/component/helper_files_modal';
import { setNavbarAction, removeNavbarAction } from "../../redux/reducers/navbar-reducer";

class AssembleShipmentResumeView extends React.Component {
  state = {
    maneuver: "load",
    currentDate: new Date(),
    selectedDate: new Date(),
    selectedDateId: new Date().toISOString().split("T")[0],
    searchStr: ""
  }

  componentDidMount() {
    this.loadFacilities();
    this.props.setBaseConfig("AssembleShipmentList", null);
    this.props.setBaseConfig("AssembleShipmentOrdersList", null);
    this.props.setNavbarAction("resume-embarques", [
      {
        icon: <HelperFilesModal
          files={[]}
        />
      }
    ]);
  }

  componentWillUnmount() {
    this.props.removeNavbarAction("resume-embarques");
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    // const { facilitiesByTagArgs } = this.props;
    switch (name) {
      case "calendar":
        this.setState(
          {
            selectedDate: value,
            selectedDateId: value.toISOString().split("T")[0],//loadFacilities
            currentDate: value,
          },
          () => this.loadFacilities()
        );
        break;
      case "maneuver":
        this.setState({ [name]: value }, () =>
          this.loadFacilities()
        );
        break;
      default:
        this.setState({ [name]: value });
    }
  };

  handleChangeDay = (e) => {
    const { currentDate } = this.state;
    // const { loadFacilities } = this.props;
    if (
      e.target &&
      e.target.attributes["name"] &&
      parseInt(e.target.attributes["name"].value) &&
      e.target.attributes["name"].value.length < 9
    ) {
      let dat = currentDate;
      let d = new Date(
        dat.getFullYear(),
        dat.getMonth(),
        dat.getDate() + parseInt(e.target.attributes["name"].value)
      );
      this.setState({ currentDate: d });
    } else if (e instanceof Date) {
      let d = new Date(e.getFullYear(), e.getMonth(), e.getDate());
      this.setState({
        selectedDate: d,
        currentDate: d,
        selectedDateId: d.toISOString().split("T")[0],
      }, () => this.loadFacilities());
      // loadFacilities(d.toISOString().split("T")[0]);
    } else if (
      e.target.attributes["name"] &&
      e.target.attributes["name"].value
    ) {
      let x = e.target.attributes["name"].value.split("-");
      let d = new Date(x[0], parseInt(x[1]) - 1, x[2]);
      this.setState(
        {
          selectedDate: d,
          selectedDateId: d.toISOString().split("T")[0],
        },
        () => this.loadFacilities()
      );
    }
  };

  loadFacilities = (/* selectedDateId: string */) => {
    const { companyId, loadShipmentResume } = this.props;
    // const { maneuver, selectedDateId } = this.state;
    // loadFacilities(companyId);
    loadShipmentResume(
      {
        company_id: companyId,
        view: 'resume',//maneuver,
        date:  '',// selectedDateId,
        facilities: this.state.filter?.selectedFacilities || "",
        transport_classes: this.state.filter?.transportClass || "",
        fleet_providers: this.state.filter?.selectedProviders || "",
        tags: this.state.filter?.selectedOrderTags || "",
      }
    );
  };

  render() {
    return (
      <View className="no-pad-bottom">
        <ViewTitle>
          <span>Resumen de embarques</span>
        </ViewTitle>
        {/* <Flex>
          <div
            style={{
              width: "300px",
              marginLeft: "50%",
              transform: "translate(-50%)",
            }}
          >
            <OptionSelectorSwitch
              value={this.state.maneuver}
              name="maneuver"
              onChange={this.handleChange}
              items={[
                { description: "Descarga", value: "unload" },
                { description: "Carga", value: "load" },
                { description: "Todo", value: "all" },
              ]}
            />
          </div>
        </Flex> */}
        <AssembleShipmentSummaryList
          history={this.props.history}
          companiesByBase={this.props.CompaniesByBase.filter(
            (base) =>
              normalizeStr(base.title || "")
                .toLowerCase()
                .includes(normalizeStr(this.state.searchStr).toLowerCase()) ||
              base.cargo_owners.find((cO) =>
                normalizeStr(cO.cargo_owner)
                  .toLowerCase()
                  .includes(normalizeStr(this.state.searchStr).toLowerCase())
              )
          )}
          handleChange={this.handleChange}
          handleChangeDay={this.handleChangeDay}
          
          currentDate={this.state.currentDate}
          selectedDate={this.state.selectedDate}
          selectedDateId={this.state.selectedDateId}
        />
      </View>
    )
  }
}

const mapStateToProps = (state) => {
  const companyId = state.globalCatalog.session.company.id;
  const CompaniesByBase = getEntityItems(state, "COMPANIES.SHIPMENTS.LT.RESUME");
  // const CompaniesByBase = RESPONSE.map(base => {
  //   // if(base.)
  //   return base
  // });
  return {
    companyId,
    CompaniesByBase
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setNavbarAction: (name, config) => dispatch(setNavbarAction(name, config)),
    removeNavbarAction: (name) => dispatch(removeNavbarAction(name)),
    setBaseConfig: (alias, config) => dispatch(setConfig(alias, config)),
    loadShipmentResume: (params, opt) => 
      dispatch(readEntities("COMPANIES.SHIPMENTS.LT.RESUME", params, opt)),
    // loadShipmentAppointments: (params, opt) => 
    //   dispatch(readEntities("COMPANIES.SHIPMENTS.LT.APPOINTMENTS", params, opt)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssembleShipmentResumeView);

const RESPONSE = [{"id":0,"title":"-","color":"-","cargo_owners":[{"id":61,"fleet_provider":37,"cargo_owner":"Mi_Empresa","logo":"images/company/pictures/Mi_Empresa.jpg","recibidos":7542,"confirmados_por_asignar":120,"confirmados_asiganados":65,"en_transito":71},{"id":321,"fleet_provider":270,"cargo_owner":"Unilever_MX_Demo","logo":"images/company/pictures/Unilever_MX_Demo.jpg","recibidos":0,"confirmados_por_asignar":0,"confirmados_asiganados":1,"en_transito":0},{"id":333,"fleet_provider":278,"cargo_owner":"BAVARIA","logo":"images/company/pictures/BAVARIA.jpg","recibidos":9,"confirmados_por_asignar":0,"confirmados_asiganados":0,"en_transito":0},{"id":347,"fleet_provider":284,"cargo_owner":"TRANSPORTES_77","logo":"images/company/pictures/TRANSPORTES_77.jpg","recibidos":1,"confirmados_por_asignar":0,"confirmados_asiganados":1,"en_transito":0},{"id":348,"fleet_provider":286,"cargo_owner":"CERVECERIA_NACIONAL_ECUADOR","logo":"images/company/pictures/CERVECERIA_NACIONAL_ECUADOR.jpg","recibidos":5,"confirmados_por_asignar":0,"confirmados_asiganados":0,"en_transito":0}]},{"id":1481,"title":"Asignacion base","color":"22B6A9","cargo_owners":[{"id":61,"fleet_provider":37,"cargo_owner":"Mi_Empresa","logo":"images/company/pictures/Mi_Empresa.jpg","recibidos":354,"confirmados_por_asignar":8,"confirmados_asiganados":6,"en_transito":4},{"id":321,"fleet_provider":270,"cargo_owner":"Unilever_MX_Demo","logo":"images/company/pictures/Unilever_MX_Demo.jpg","recibidos":0,"confirmados_por_asignar":0,"confirmados_asiganados":1,"en_transito":0}]},{"id":1429,"title":"CALERA","color":"FFA517","cargo_owners":[{"id":61,"fleet_provider":37,"cargo_owner":"Mi_Empresa","logo":"images/company/pictures/Mi_Empresa.jpg","recibidos":442,"confirmados_por_asignar":4,"confirmados_asiganados":21,"en_transito":3}]},{"id":1700,"title":"CCZ","color":"FFA517","cargo_owners":[]},{"id":1496,"title":"Prueba cargador","color":"EB496B","cargo_owners":[]},{"id":1704,"title":"Prueba etiqueta duplicada 1","color":"EB496B","cargo_owners":[]},{"id":1468,"title":"Pruebas Orbi 2001","color":"B84CBE","cargo_owners":[{"id":61,"fleet_provider":37,"cargo_owner":"Mi_Empresa","logo":"images/company/pictures/Mi_Empresa.jpg","recibidos":1,"confirmados_por_asignar":4,"confirmados_asiganados":6,"en_transito":4}]},{"id":799,"title":"TORREON","color":"3D77F7","cargo_owners":[{"id":61,"fleet_provider":37,"cargo_owner":"Mi_Empresa","logo":"images/company/pictures/Mi_Empresa.jpg","recibidos":4,"confirmados_por_asignar":0,"confirmados_asiganados":2,"en_transito":8}]}]